import { Frequency } from '../types-enums';

export class DateTime {
    date: Date;
    constructor(value: Date | { year: number, month: number, day: number }) {
        if (value instanceof Date) {
            this.date = value;
            return;
        }
        if ('year' in value && 'month' in value && 'day' in value) {
            const v = value as { year: number, month: number, day: number };
            this.date = new Date(v.year, v.month, v.day);
            return;
        }
        throw new Error('Invalid Arguments in DateTime constructor');
    }
    static get Today() {
        return new DateTime(new Date());
    }
    get JavaScriptDate() {
        return this.date;
    }
    get Day() {
        return this.date.getDate();
    }
    get DayOfWeek() {
        return this.date.getDay();
    }
    get Month() {
        return this.date.getMonth();
    }
    get Year() {
        return this.date.getFullYear();
    }
    AddDays(value: number) {
        const d = new Date(this.date);
        const diff = d.getDate() + value;
        return new DateTime(new Date(d.setDate(diff)));
    }
    AddMonths(value: number) {
        const d = new Date(this.date);
        const diff = d.getMonth() + value;
        return new DateTime(new Date(d.setMonth(diff)));
    }
}
export function nextTopupDate(frequency: Frequency, topupDay: number, holdingDays: number = 2): Date {
    const date = NextTopupDate(frequency, topupDay, holdingDays);
    return date.JavaScriptDate;
}
function getDayOfHalfMonth(date: DateTime): number {
    const day = date.Day;
    if (day >= 1 && day <= 15) return day;
    if (day < 30) return day - 15;
    return 30;
}
function NextTopupDate(frequency: Frequency, topupDay: number, holdingDays: number): DateTime {
    const today = DateTime.Today.AddDays(holdingDays);
    if (frequency === Frequency.Weekly) {
        let dayOfWeek: number = today.DayOfWeek;
        if (dayOfWeek === 0) dayOfWeek = 7;     // Javscript uses 0 for sunday. We use 7 for Sunday
        let startDate: DateTime;
        if (topupDay > dayOfWeek) startDate = today.AddDays(topupDay - dayOfWeek);
        else startDate = today.AddDays(topupDay + 7 - dayOfWeek);
        return startDate;
    } else if (frequency === Frequency.BiWeekly) {
        const dayOfHalfMonth: number = getDayOfHalfMonth(today);
        let startDate: DateTime;
        if (topupDay > dayOfHalfMonth) {
            startDate = today.AddDays(topupDay - dayOfHalfMonth);
        }
        else {
            const year = today.Year;
            const month = today.Month;
            const isDateInFirstHalf = today.Day <= 15;
            if (isDateInFirstHalf) {
                startDate = new DateTime({ year, month, day: 16 }).AddDays(topupDay - 1);
            } else {
                startDate = new DateTime({ year, month, day: 1 }).AddMonths(1).AddDays(topupDay - 1);
            }
        }
        return startDate;
    } else {
        let dayOfMonth = today.Day;
        if (dayOfMonth === 31) dayOfMonth = 30;
        let startDate: DateTime;
        if (topupDay > dayOfMonth) {
            startDate = today.AddDays(topupDay - dayOfMonth);
        } else {
            const year = today.Year;
            const month = today.Month;
            startDate = new DateTime({ year, month, day: 1 }).AddMonths(1).AddDays(topupDay - 1);
        }
        return startDate;
    }
}
function weekDaysFunc() {
    return [
        { value: 1, label: 'Monday' },
        { value: 2, label: 'Tuesday' },
        { value: 3, label: 'Wednesday' },
        { value: 4, label: 'Thursday' },
        { value: 5, label: 'Friday' },
        { value: 6, label: 'Saturday' },
        { value: 7, label: 'Sunday' }];
}
function biWeekDaysFunc() {
    const days = Array.from(new Array(15), (x, index: number) => index + 1);
    return days.map(value => ({ value: value, label: `${value}` }));
}
function monthDaysFunc() {
    const days = Array.from(new Array(30), (x, index: number) => index + 1);
    return days.map(value => ({ value: value, label: `${value}` }));
}
export const weekDays = weekDaysFunc();
export const biWeekDays = biWeekDaysFunc();
export const monthDays = monthDaysFunc();

export function humanizeDay(topupDay: number, freq: Frequency) {
    const j = topupDay % 10;
    const k = topupDay % 100;
    if (freq === Frequency.Weekly) {
        return weekDays[topupDay - 1].label;
    }
    const day = j === 1 && k !== 11 ?
        topupDay + 'st' : j === 2 && k !== 12 ?
            topupDay + 'nd' : j === 3 && k !== 13 ?
                topupDay + 'rd' : topupDay + 'th';
    return day + ' day';
}
